const makeLink = (value, base) => {
	if (!value) {
		return false;
	}

	value = value.trim();

	// 1. Value is a COMPLETE value url
	if (value.indexOf("http") === 0) {
		return value;
	}

	// 2. Value is a URL, but without http
	if (value.indexOf(base) >= 0) {
		return `https://${value}`;
	}

	// 3. Value is a username with or without '@'

	return `https://${base}/${value.substr(value.charAt(0) === "@" ? 1 : 0)}`;
};

export default makeLink;
